import { ColumnsType } from 'antd/lib/table';
import { MedVoxEvent } from '../../../models/MedVox/MedVoxEvent';

export const COLUMNS: ColumnsType<MedVoxEvent> = [
  {
    title: 'Время создания',
    dataIndex: 'createdDate',
    responsive: ['sm'],
    align: 'center' as const,
  },

  {
    title: 'Источник события',
    dataIndex: 'source',
    responsive: ['sm'],
    align: 'center' as const,
  },
  {
    title: 'Тип события',
    dataIndex: 'eventType',
    responsive: ['sm'],
    align: 'center' as const,
  },
  {
    title: 'Текст события',
    dataIndex: 'message',
    responsive: ['sm'],
    align: 'center' as const,
  },
];
